import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
}

const HouseBuildingOutline = createIcon({
  displayName: 'HouseBuildingOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0 0h24v24h-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M3.734 9.764l8.268-6.764 8.265 6.764c.464.379.733.948.733 1.547v7.689c0 1.105-.895 2-2 2h-14c-1.105 0-2-.895-2-2v-7.688c0-.6.269-1.169.734-1.548Z"
        ></path>
      </g>
    </>
  ),
})

const HouseBuilding: FC<CustomIconProps> = (props) => {
  return <CustomIcon as={HouseBuildingOutline} {...props} />
}

export default memo(HouseBuilding)
